<div *ngIf="!isLoading" class="container">
    <div class="invoice-card">
        <!-- Invoice Header -->
        <div class="invoice-header">
            <div class="header-content">
                <h1 class="invoice-title">
                    <i class="fas fa-file-invoice"></i>
                    <span class="title-text">Facture</span>
                    <span class="invoice-id">#{{orderDetails?.id}}</span>
                </h1>
                <div class="action-buttons">
                    <button class="btn btn-white" (click)="printInvoice()" title="Imprimer la facture">
                        <i class="fas fa-print"></i>
                        <span class="btn-text">Imprimer</span>
                    </button>
                    <button class="btn btn-white" (click)="goToOrderEdit(orderDetails)" title="Modifier la facture">
                        <i class="fas fa-edit"></i>
                        <span class="btn-text">Modifier</span>
                    </button>
                    <button class="btn btn-delete" (click)="deleteOrder()" title="Supprimer la facture">
                        <i class="fas fa-trash"></i>
                        <span class="btn-text">Supprimer</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="invoice-body">
            <!-- Status Section -->
            <div class="status-section">
                <div class="order-date" *ngIf="orderDetails">
                    <i class="fas fa-calendar-alt"></i>
                    {{setOrderDate(orderDetails)}}
                </div>
                <div class="status">
                    <span *ngIf="orderDetails?.isOrderPaid()===true" class="status-badge paid">
                        <i class="fas fa-check-circle"></i>
                        Payée
                    </span>
                    <span *ngIf="orderDetails?.isOrderPaid()===false" class="status-badge unpaid">
                        <i class="fas fa-times-circle"></i>
                        Impayé
                    </span>
                    <span *ngIf="orderDetails?.isVirtual" class="status-badge paid"
                        style="background-color: #FEF3C7; color: #D97706;">
                        <i class="fas fa-bolt"></i>
                        Virtuelle
                    </span>
                </div>
            </div>

            <!-- Info Grid -->
            <div class="info-grid">
                <div class="info-card">
                    <h3>
                        <i class="fas fa-user"></i>
                        Client
                    </h3>
                    <div class="content">
                        <div class="name">{{orderDetails?.clientDTO?.firstName}} {{orderDetails?.clientDTO?.lastName}}
                        </div>
                        <div>
                            <i class="fas fa-phone"></i>
                            {{orderDetails?.clientDTO?.phoneNumber}}
                        </div>
                    </div>
                </div>
                <div class="info-card">
                    <h3>
                        <i class="fas fa-info-circle"></i>
                        Détails de la commande
                    </h3>
                    <div class="content">
                        <div>
                            <i class="fas fa-hashtag"></i>
                            Numéro de facture: #{{orderDetails?.id}}
                        </div>
                        <div>
                            <i class="fas fa-money-bill-wave"></i>
                            Méthode de paiement: Cash
                        </div>
                    </div>
                </div>
            </div>

            <!-- Order Items Table -->
            <div class="table-container">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="mobile-hide">#</th>
                                <th>Article</th>
                                <th class="desktop-only">Prix unitaire</th>
                                <th class="desktop-only">Quantité</th>
                                <th class="desktop-only" style="text-align: right">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let orderLine of orderDetails?.orderLines; let i = index; let last = last"
                                [class.last-row]="last">
                                <td class="mobile-hide">{{i + 1}}</td>
                                <td>
                                    <div class="product-info">
                                        <i class="fas fa-box"></i>
                                        <span [title]="orderLine.product?.name"
                                            (touchstart)="startLongPress($event, orderLine.product?.name)"
                                            (touchend)="endLongPress()" (touchmove)="endLongPress()"
                                            class="product-name">{{orderLine.product?.name}}</span>
                                    </div>
                                    <div class="mobile-only product-details">
                                        <div class="mobile-row">
                                            <span class="amount">MAD {{orderLine.realSellingPrice}}</span>
                                            <span class="qty-indicator">
                                                <i class="fas fa-times"></i>
                                                {{orderLine.quantity - (orderLine.returnedQuantity || 0)}}
                                            </span>
                                            <span class="mobile-returned-hint" *ngIf="(orderLine.returnedQuantity || 0) > 0">
                                                <i class="fas fa-undo-alt"></i> {{orderLine.returnedQuantity}} retourné(s)
                                            </span>
                                            <span class="mobile-total amount">MAD {{(orderLine.quantity - (orderLine.returnedQuantity || 0)) * (orderLine.realSellingPrice || 0) | number:'1.2-2'}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="desktop-only amount">MAD {{orderLine.realSellingPrice}}</td>
                                <td class="desktop-only" style="text-align: center;">
                                    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                                        <span class="font-medium text-gray-700">
                                            <i class="fas fa-times"></i> {{orderLine.quantity - (orderLine.returnedQuantity || 0)}}
                                        </span>
                                        <span class="badge-returned" *ngIf="(orderLine.returnedQuantity || 0) > 0">
                                            <i class="fas fa-undo-alt"></i> {{orderLine.returnedQuantity}} retourné
                                        </span>
                                    </div>
                                </td>
                                <td class="desktop-only amount" style="text-align: right">
                                    <div class="flex flex-col items-end">
                                        <span class="font-bold text-gray-700">
                                            MAD {{(orderLine.quantity - (orderLine.returnedQuantity || 0)) * (orderLine.realSellingPrice || 0) | number:'1.2-2'}}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                                <ng-container *ngFor="let avoir of avoirs; let i = index">
                                    <!-- Avoir Header Row -->
                                    <tr class="avoir-header-row" (click)="toggleAvoir(avoir.id)">
                                        <td colspan="5" class="avoir-header-cell">
                                            <div class="flex justify-between items-center text-sm">
                                                <div class="flex items-center gap-4">
                                                    <i class="fas fa-undo-alt text-red-600"></i>
                                                    <div class="flex flex-col">
                                                        <span class="avoir-title">Avoir N° {{avoir.id}}</span>
                                                        <span class="text-[10px] text-red-400 font-medium tracking-tight">{{avoir.approvalDate | date:'dd MMM, yyyy'}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex items-center gap-5">
                                                    <div class="flex items-center gap-3">
                                                        <span *ngIf="avoir.amountAbsorbedFromDebt && avoir.amountAbsorbedFromDebt > 0" class="avoir-badge-secondary avoir-badge-debt">
                                                            Dette: -MAD {{avoir.amountAbsorbedFromDebt | number:'1.2-2'}}
                                                        </span>
                                                        <span *ngIf="avoir.discountAdjustment && avoir.discountAdjustment > 0" class="avoir-badge-secondary avoir-badge-adj">
                                                            Réduc: +MAD {{avoir.discountAdjustment | number:'1.2-2'}}
                                                        </span>
                                                        <div class="avoir-amount-pill">
                                                            <span class="avoir-amount-label">Restitué</span>
                                                            <span class="avoir-amount-value">-MAD {{ (avoir.amountRefundedInCash !== undefined ? avoir.amountRefundedInCash : avoir.totalRefund) | number:'1.2-2' }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="avoir-chevron" [class.rotated]="isAvoirExpanded(avoir.id)">
                                                        <i class="fas fa-chevron-down"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Avoir Expanded Detail Row -->
                                    <tr>
                                        <td colspan="5" class="p-0 border-0">
                                            <div class="avoir-expand-wrapper" [class.expanded]="isAvoirExpanded(avoir.id)">
                                                <div class="border-b border-red-100">
                                                    <div *ngFor="let line of avoir.avoirLines" class="avoir-item-row flex flex-col md:flex-row md:justify-between md:items-center py-2.5 px-10 lg:px-14 gap-2 md:gap-0">
                                                        <div class="flex items-center gap-3 w-full md:w-1/2">
                                                            <i class="fas fa-arrow-right text-red-200 text-[10px]"></i>
                                                            <span class="text-sm avoir-line-name">{{line.product?.name}}</span>
                                                        </div>
                                                        <div class="flex justify-between md:justify-end items-center gap-4 md:gap-10 w-full md:w-auto text-sm text-red-800">
                                                            <span class="md:w-24 md:text-right font-medium opacity-70">MAD {{line.refundSellingPrice | number:'1.2-2'}}</span>
                                                            <span class="px-2.5 py-0.5 bg-white border border-red-100 rounded-full text-[10px] font-bold text-red-900 shadow-sm">×{{line.quantityReturned}}</span>
                                                            <span class="md:w-28 text-right avoir-line-total">MAD {{(line.quantityReturned * (line.refundSellingPrice || 0)) | number:'1.2-2'}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>

            <!-- Summary Section -->
            <div class="summary-barcode-container">
                <div class="summary-card">
                    <div class="summary-row compact">
                        <span>Sous-total</span>
                        <span class="amount">MAD {{getInitialGrossTotal() | number:'1.2-2'}}</span>
                    </div>
                    <div class="summary-row compact">
                        <span>Réduction</span>
                        <span class="amount">-MAD {{orderDetails?.discount | number:'1.2-2'}}</span>
                    </div>
                    <div class="summary-row compact" *ngIf="orderDetails?.hasReturns">
                        <span>Avoirs</span>
                        <span class="amount">-MAD {{calculateGrossAvoirsTotal() | number:'1.2-2'}}</span>
                    </div>
                    <div class="summary-row compact" *ngIf="!orderDetails?.isOrderPaid() && (orderDetails?.advancePayment ?? 0) > 0">
                        <span>Avance</span>
                        <span class="amount">MAD {{orderDetails?.advancePayment | number:'1.2-2'}}</span>
                    </div>

                    <div class="summary-row total mt-2 pt-2 border-t-2">
                        <span>Total {{ orderDetails?.hasReturns ? 'Rectifié' : '' }}</span>
                        <span class="amount">MAD {{ getInitialGrossTotal() - (orderDetails?.discount || 0) - calculateGrossAvoirsTotal() | number:'1.2-2' }}</span>
                    </div>

                    <div *ngIf="!orderDetails?.isOrderPaid()" class="summary-row total-rectified bg-red-50 px-2 mt-1 rounded">
                        <span class="label text-red-700">Reste à payer:</span>
                        <span class="amount text-red-700 font-black">MAD {{ (getInitialGrossTotal() - (orderDetails?.discount || 0) - calculateGrossAvoirsTotal()) - (orderDetails?.advancePayment ?? 0) | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Confirmation Dialog - Moved outside to prevent transform stacking context issues -->
<app-confirmation-dialog [isVisible]="showDeleteConfirmation" title="Confirmer la suppression"
    message="Êtes-vous sûr de vouloir supprimer cette facture ? Cette action est irréversible." confirmText="Supprimer"
    cancelText="Annuler" type="danger" (confirm)="confirmDelete()" (cancel)="cancelDelete()" (close)="cancelDelete()">
</app-confirmation-dialog>